import React from "react";

const ThemeTitle = ({ whiteColor = null, primaryColor = null }) => (
  <div className="text-center">
    <h1 className="display-4 font-weight-bold mb-5">
      <span className="text-white">{whiteColor}</span>{" "}
      <span className="text-primary">{primaryColor}</span>
    </h1>
  </div>
);

export default ThemeTitle;
